import { styled } from "@material-ui/core";
import { Button } from "lqx-react";

export const ActivationButton = styled(Button)({
    fontFamily: 'Montserrat',
    fontSize: '14px',
    backgroundColor: 'transparent',
    color: '#052C4C',
    borderRadius: '20px',
    border: (props: any) => props.active === true ? '1px solid #052C4C' : 'none',
    width: 'fit-content',
    fontWeight: 500,
    '&:active': {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        backgroundColor: 'transparent',
        color: '#052C4C',
        borderRadius: '20px',
        border: (props: any) => props.active === true ? '1px solid #052C4C' : 'none',
        boxShadow: 'none',
        fontWeight: 500
    },
    '&:focus': {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        backgroundColor: 'transparent',
        color: '#052C4C',
        borderRadius: '20px',
        border: (props: any) => props.active === true ? '1px solid #052C4C' : 'none',
        boxShadow: 'none',
        fontWeight: 500
    },
    '&:hover': {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        backgroundColor: 'transparent',
        color: '#052C4C',
        borderRadius: '20px',
        border: () => '1px solid #052C4C',
        boxShadow: '2px 0 4px 0 rgb(0 0 0 / 10%)',
        fontWeight: 600
    }
});